import React from 'react';

import { Button, Flexbox } from '@morressier/ts';

import { useAuthedUser } from 'hooks/useIsAuthedUser';
import { useLogIn } from 'hooks/useLogIn';
import { useRegAndTicketingContext } from 'store/modules/eventTicketing';

import { SignUpBannerText, SignUpBannerWrapper as Wrapper } from './styles';

const SignUpBanner: React.FC<{
  event?: MorressierEvent;
}> = props => {
  const { handleLogIn } = useLogIn();

  return (
    <Wrapper>
      <SignUpBannerText>Log In to participate in the discussion</SignUpBannerText>
      <Flexbox>
        <Button
          color="primary"
          onClick={() => {
            const {
              _id: eventId,
              name: eventName,
              organization_id,
              short_name: shortName,
            } = props?.event || {};

            handleLogIn({ eventId, eventName, shortName, orgName: organization_id?.acronym });
          }}
        >
          Log In
        </Button>
      </Flexbox>
    </Wrapper>
  );
};

export const SessionBlockedQnA = () => {
  const { state } = useRegAndTicketingContext();
  const isAuthed = useAuthedUser();

  return (
    <Wrapper style={{ margin: '1rem 0', minHeight: 'unset', padding: '1rem 0.5rem' }}>
      <SignUpBannerText>
        {!isAuthed && 'Sign in or'} {state?.isTicketedEvent ? 'Buy a Ticket' : 'Register'} to
        participate in the discussion.
      </SignUpBannerText>
    </Wrapper>
  );
};

export default SignUpBanner;
